var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPte(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    rx: 2,
    fill: "#426AFF",
    fillOpacity: 0.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 7C6.45 7 5.97917 6.80417 5.5875 6.4125C5.19583 6.02083 5 5.55 5 5C5 4.45 5.19583 3.97917 5.5875 3.5875C5.97917 3.19583 6.45 3 7 3C7.55 3 8.02083 3.19583 8.4125 3.5875C8.80417 3.97917 9 4.45 9 5C9 5.55 8.80417 6.02083 8.4125 6.4125C8.02083 6.80417 7.55 7 7 7ZM3 11V9.6C3 9.31667 3.073 9.05617 3.219 8.8185C3.365 8.58083 3.55867 8.39967 3.8 8.275C4.31667 8.01667 4.84167 7.82283 5.375 7.6935C5.90833 7.56417 6.45 7.49967 7 7.5C7.55 7.5 8.09167 7.56467 8.625 7.694C9.15833 7.82333 9.68333 8.017 10.2 8.275C10.4417 8.4 10.6355 8.58133 10.7815 8.819C10.9275 9.05667 11.0003 9.317 11 9.6V11H3Z",
    fill: "#426AFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPte);
export default __webpack_public_path__ + "static/media/icon-pte.1452719a26f3d732baa690650081703c.svg";
export { ForwardRef as ReactComponent };